import React from "react";
import PageHeading from "../../../../components/common/PageHeading";
import { Form, Col, Row, Card } from "antd";
import FormAction from "../../../../components/common/FormAction";
import ScheduledReportsEdit from "../Components/ScheduledReportsEdit";

function NewScheduledReport() {
  return (
    <>
      <PageHeading heading="New Scheduled Report" />

      <Form
        name="basic"
        labelCol={{ span: 7 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        className="form-container"
        colon={false}
      >
        <Row>
          <Col span={24}>
            {/* PROPERY NAME AND ADDRESS CARD STARTS */}

            <Card title="Schedule Details" bordered={false}>
              <ScheduledReportsEdit />
            </Card>

            <br />

            <FormAction />
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar"></div>
    </>
  );
}

export default NewScheduledReport;
